module.exports = __webpack_public_path__ + "static/accounts_aws_china_secrets_2-2c0013fe555cfc719d7e8f3da196e1bf.png";